<!-- Generated template for the GoogleMapsComponent component -->
<div class="google_maps" #maps>

</div>